//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export ImplementationConfig
export const EmployeeFundsPanelConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path     : '/app/ewa/panel',
      component: FuseLoadable({
          loader: () => import('./BankRecForm')
      })
  }
  ]
  //end routes
};
